const validateForm = (
  {
    name,
    heightMin,
    heightMax,
    weightMin,
    weightMax,
    lifeSpanMin,
    lifeSpanMax,
  },
  temps
) => {
  heightMin = Number(heightMin);
  heightMax = Number(heightMax);
  weightMin = Number(weightMin);
  weightMax = Number(weightMax);
  lifeSpanMin = Number(lifeSpanMin);
  lifeSpanMax = Number(lifeSpanMax);
  const errors = {};
  if (!name.length) errors.name = "The breed must have a name";
  else if (name[0] !== name[0].toUpperCase())
    errors.name = "The name of the breed must begin with a capital letter";

  if (heightMin <= 0 || heightMax <= 0) {
    errors.height = "The breed must have a minimum and maximum height";
  } else if (heightMin > heightMax) {
    errors.height = "The minimum height cannot be greater than the maximum";
  } else if (heightMax > 110)
    errors.height = "The maximum height cannot be greater than 110 cm";

  if (weightMin <= 0 || weightMax <= 0)
    errors.weight = "The breed must have minimum and maximum weight";
  else if (weightMin > weightMax) {
    errors.weight = "The minimum weight can be greater than the maximum weight";
  } else if (weightMax > 100)
    errors.weight = "The maximum weight cannot be greater than 100 Kgs";

  if (lifeSpanMin <= 0 || lifeSpanMax <= 0)
    errors.lifeSpan = "Breed should minimum and maximum life span";
  else if (lifeSpanMin > lifeSpanMax) {
    errors.lifeSpan =
      "The minimum life expectancy cannot be greater than the maximum life span";
  } else if (lifeSpanMax > 20)
    errors.lifeSpan =
      "The maximum life span cannot exceed 20 years";

  if (!temps.length)
    errors.temps = "The breed must have at least one temperament type";

  return errors;
};

export default validateForm;
